/** A custom error to be thrown when an expected error was encountered, and form submission should be stopped without reporting the error to Sentry */
export default class ExpectedFormError extends Error {
	constructor() {
		super();
		this.name = 'ExpectedFormError';
	}
}
